<template>
  <div class="cooperation">
    <!-- 头部 -->
    <v-header></v-header>
    <!-- 广告 -->
    <div class="banner">
      <img src="../assets/images/pc_lx_banner.png" alt width="100%" />
    </div>
    <!-- 内容 -->
    <div class="con">
      <div class="center">
        <div class="center">
          <!-- <div>
            <h2 style="font-weight: 500;">聯絡客服/銷售人員</h2>
            <div style="margin: 20px;"></div>
            <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
              <el-form-item label="稱謂">
                <el-input v-model="formLabelAlign.name"></el-input>
              </el-form-item>
              <el-form-item label="聯絡電話">
                <el-input v-model="formLabelAlign.region"></el-input>
              </el-form-item>
              <el-form-item label="電郵地址">
                <el-input v-model="formLabelAlign.type"></el-input>
              </el-form-item>
              <el-form-item label="詳情" >
                <el-input type="textarea" v-model="formLabelAlign.desc" :rows="5"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">立即創建</el-button>
                <el-button>取消</el-button>
              </el-form-item>
            </el-form>
          </div>-->
          <!-- <div class="call2">
            <h2>{{$t('message.contact.content.title')}}</h2>
            <div>
              <i class="el-icon-phone-outline"></i>
              <p>{{$t('message.contact.content.phone')}}</p>
            </div>
            <div>
              <i class="el-icon-s-comment"></i>
              <p>{{$t('message.contact.content.whatsapp')}}</p>
            </div>
            <div>
              <i class="el-icon-location-information"></i>
              <p>{{$t('message.contact.content.address')}}</p>
            </div>
            <div>
              <i class="el-icon-position"></i>
              <p>{{$t('message.contact.content.email')}}</p>
            </div>
          </div>
          <div class="Social">
              <h1>{{$t('message.contact.content.title2')}}</h1>
              <div>
                <a href="https://www.facebook.com/caterawayhongkong">
                  <div>
                    <img src="../assets/images/facebook.png" alt="">
                    <p style="text-align: center; margin-top:10%">Facebook</p>
                  </div>
                </a>
                <a href="https://www.instagram.com/cateraway/">
                  <div style="margin-top:2rem">
                    <img src="../assets/images/im.png" alt="" width="75" height="75">
                    <p style="text-align: center; margin-top:10%">Instagram</p>
                  </div>
                </a>
              </div>
          </div>-->
          <h1 class="top">
            <img
              style="padding: 0 0 7px 0"
              src="../assets/images/pc_hz_title_line1.png"
              alt
            />
            {{ $t("message.contact.content.title") }}
            <img
              style="padding: 0 0 7px 0"
              src="../assets/images/pc_hz_title_line2.png"
              alt
            />
          </h1>
          <div class="con-s">
            <div>
              <div class="cons-t">
                <div>
                  <i class="el-icon-phone-outline"></i>
                  <span>{{ $t("message.contact.content.phone") }}</span>
                </div>
                <div>
                  <i class="el-icon-s-comment"></i>
                  <span>{{ $t("message.contact.content.whatsapp") }}</span>
                </div>
                <div>
                  <i class="el-icon-location-information"></i>
                  <span>{{ $t("message.contact.content.address") }}</span>
                </div>
                <div>
                  <i class="el-icon-position"></i>
                  <span>{{ $t("message.contact.content.email") }}</span>
                </div>
              </div>
            </div>
            <div>
              <!-- <img src="../assets/images/pc_lx_contact_img_map.png" width="100%" height="100%" alt=""> -->
              <div class="cons-b">
                <div style="text-align: center">
                  <a
                    target="_black"
                    style="text-decoration: none; color: #3b3937"
                    href="https://www.facebook.com/caterawayhongkong"
                  >
                    <div>
                      <img
                        src="../assets/images/pc_lx_contact_content2_fb.png"
                        alt
                      />
                      <p>Facebook</p>
                    </div>
                  </a>
                </div>
                <div style="text-align: center">
                  <a
                    target="_black"
                    style="text-decoration: none; color: #3b3937"
                    href="https://www.instagram.com/cateraway/"
                  >
                    <div>
                      <img
                        src="../assets/images/pc_lx_contact_content2_ig.png"
                        alt
                      />
                      <p>Instagram</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="conmo">
      <div>
        <div class="cons-t" style="padding: 0 17px">
          <div>
            <i class="el-icon-phone-outline"></i>
            <span>{{ $t("message.contact.content.phone") }}</span>
          </div>
          <div>
            <i class="el-icon-s-comment"></i>
            <span>{{ $t("message.contact.content.whatsapp") }}</span>
          </div>
          <div>
            <i class="el-icon-location-information"></i>
            <span>{{ $t("message.contact.content.address") }}</span>
          </div>
          <div>
            <i class="el-icon-position"></i>
            <span>{{ $t("message.contact.content.email") }}</span>
          </div>
        </div>
        <div class="cons-b">
          <div style="text-align: center">
            <a
              target="_black"
              style="text-decoration: none; color: #3b3937"
              href="https://www.facebook.com/caterawayhongkong"
            >
              <div>
                <img
                  src="../assets/images/pc_lx_contact_content2_fb.png"
                  alt
                  width="70px"
                  height="70px"
                />
                <p>Facebook</p>
              </div>
            </a>
          </div>
          <div style="text-align: center">
            <a
              target="_black"
              style="text-decoration: none; color: #3b3937"
              href="https://www.instagram.com/cateraway/"
            >
              <div>
                <img
                  src="../assets/images/pc_lx_contact_content2_ig.png"
                  alt
                  width="70px"
                  height="70px"
                />
                <p>Instagram</p>
              </div>
            </a>
          </div>
        </div>
      </div>
      <!-- <div style="padding: 20px 0">
        <img src="../assets/images/lx_contact_img.png" alt="" width="100%" height='200px'>
      </div>-->
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import header from "../components/header";
export default {
  name: "index",
  data() {
    return {
      labelPosition: "top",
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
        desc: ""
      },
      i: true
    };
  },
  methods: {
    onSubmit() {},
    chil() {
      if (this.i === true) {
        $(".phone-header-top").css("overflow", "inherit");
        this.i = false;
      } else if (this.i === false) {
        $(".phone-header-top").css("overflow", "hidden");
        this.i = true;
      }
    }
  },
  components: {
    "v-header": header,
  }
};
</script>

<style scoped>
.conmo {
  display: none;
}
/* 页头 */
.center {
  width: 85%;
  height: 100%;
  margin: auto;
  overflow: hidden;
}
.banner .el-button.el-button--success {
  display: block;
  width: 10rem;
  margin: 110px auto 0 auto;
}
/* 内容 */
.con .center > .con-s {
  width: 100%;
  overflow: hidden;
}
.con-s > div {
  float: left;
  width: 50%;
}
.con-s {
  height: 270px;
}
.cons-t > div {
  margin: 30px 0;
  font-size: 16px;
}
.con-s > div:nth-child(1) {
  padding: 0 30px;
  box-sizing: border-box;
}
.cons-b {
  overflow: hidden;
}
.cons-b > div {
  float: left;
  width: 50%;
  margin: 30px 0 0 0;
}
.cooperation {
  background: #fff;
}
.con {
  margin: 2% 0 0% 0;
}
.con h1 {
  text-align: center;
  font-size: 1.6rem;
  font-weight: 500;
}
.con .center > p {
  margin: 3% 0;
  text-align: center;
  font-size: 18px;
  font-weight: 200;
}
.Social > div {
  text-align: center;
}
.con .center .center > div:nth-child(1) {
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
}
.el-form-item__content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 1%;
}
.el-form-item {
  margin-bottom: 0;
}
.con h1 {
  margin: 2% 0 5% 0;
}
.call h2 {
  font-weight: 500;
}
/* 广告 */
.banner .el-button.el-button--success {
  display: block;
  width: 10rem;
  margin: 2% auto 0 auto;
}
.banner {
  margin: 110px 0;
  /* position: relative; */
  width: 100%;
}
.banner h1,
.banner p {
  text-align: center;
  color: white;
}
.banner h1 {
  font-weight: bold;
  font-size: 2rem;
}
.banner p {
  margin: 1% 0;
  font-size: 25px;
}
.banner .center {
  width: 80%;
  height: 30%;
  /* position: absolute; */
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  margin: auto;
}
/* 合作 */
.Cooperation p {
  text-align: center;
  color: #95989d;
  font-size: 1.09375rem;
  font-weight: 300;
  margin-top: 0;
  margin-bottom: 1rem;
}
/* 頁尾 */
footer {
  margin: 3% 0 0 0;
  height: 10rem;
  background: black;
}
footer > div > div {
  margin: 2% 0 0 0;
  color: #95989d;
  font-size: 0.75rem;
  font-weight: 400;
  margin-bottom: 1rem;
  text-align: center;
}
.call2 > p {
  margin: 3% 0;
  font-size: 0.88rem;
  font-weight: 300;
}
.call2 > div {
  color: black;
  margin: 10% 0;
}
.call2 i {
  display: inline-block;
  font-size: 2rem;
}
.call2 > div > p {
  margin: 3% 0;
}
.Social {
  margin: 0 0 5% 0;
}
.Social > h1 {
  font-weight: 500;
  margin: 5% 0 3% 0;
  text-align: center;
}
.Social > p {
  text-align: center;
}
.Social > a > div {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
}
.Social a {
  color: black;
}
.Social > div > a > div {
  margin: auto;
  padding: 3%;
  width: 70%;
  box-shadow: 0 5px 18px 3px rgba(0, 0, 0, 0.1);
}
.Social > div > a > div > img {
  display: block;
  margin: auto;
}
/* 移动端 */
@media (max-width: 820px) {
  .con {
    display: none;
  }
  .conmo {
    display: block;
    margin-bottom: 20px;
  }
  .banner {
    background: url("../assets/images/pc_lx_banner.png");
    background-size: 100% 100%;
  }
  .banner .center {
    width: 95%;
    height: 45%;
  }
  .banner p {
    margin: 1% 0;
    font-size: 13px;
  }
  .banner {
    height: 170px;
    margin: 135px 0 0 0;
  }
  .phone-header-top {
    display: block;
  }
  .center {
    width: 100%;
  }
  .con .center .center > div {
    width: 80%;
    padding: 5%;
    float: none;
    margin: auto;
  }
  .con .center > p {
    padding: 0 10%;
    margin: 5% 0;
    font-size: 13px;
  }
  .Social .center > h1 {
    font-size: 21px;
  }
  .call2 > p {
    font-size: 13px;
    margin: 5% 0;
  }
  .con h1 {
    margin: 5% 0;
  }
  .call2 h2 {
    text-align: center;
  }
  .el-dialog {
    width: 100% !important;
    margin: 0 !important;
  }
  .con h1 {
    margin: 5% 0 5% 0;
  }
}
</style>
<style>
.cooperation .el-form-item__content {
  text-align: center;
}
.cooperation .el-button--primary {
  margin-top: 5%;
}
.cooperation .header .el-button--primary {
  margin: 0;
}
.cooperation .el-button.el-button--primary {
  background: #eb6410;
  border: #eb6410;
}
</style>
